export default "__VITE_ASSET__Pe8HihoZ__"